import { render, staticRenderFns } from "./RulesetGroupItem.vue?vue&type=template&id=19ca5092"
import script from "./RulesetGroupItem.vue?vue&type=script&lang=js"
export * from "./RulesetGroupItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports